<ng-template #templateCookiesManagementModal>
    <div class="modal-cookie-management">
        <div class="modal-header">
            <div class="d-flex flex-column">
                <h4 class="modal-title">{{ 'geral.cookie-management.header.title' | translate }}</h4>
                <span class="modal-subtitle">
                    <span>{{ 'geral.cookie-management.header.subtitle.text' | translate }} <span class="cookie-policy" (click)="openCookiePolicy()">{{ 'geral.cookie-management.header.subtitle.url' | translate }}</span></span>
                </span>
            </div>
            <button type="button" data-dismiss="modal" aria-label="Close" class="btn-close" (click)="close();"></button>
        </div>
        <div class="modal-body">
            <div class="content">
                <div class="cookies-container">
                    <div class="cookie">
                        <div class="left-side">
                            <p>{{ ('geral.cookie-management.cookies.required.always-active') | translate }}</p>
                        </div>
                        <div class="right-side">
                            <h5>{{ ('geral.cookie-management.cookies.required.name') | translate }}</h5>
                            <p>{{ ('geral.cookie-management.cookies.required.description') | translate }}</p>
                        </div>
                    </div>
                    @for (cookie of optionalCookies; track cookie) {
                        <div class="cookie">
                            <div class="left-side">
                                <label class="switch switch-lg">
                                    <input id="{{cookie.name}}Toggle" type="checkbox" (click)="toggleCookieSelection(cookie)"/>
                                    <span></span>
                                </label>
                            </div>
                            <div class="right-side">
                                <h5>{{ ('geral.cookie-management.cookies.' + cookie.name + '.name') | translate }}</h5>
                                <p>{{ ('geral.cookie-management.cookies.' + cookie.name + '.description') | translate }}</p>
                            </div>
                        </div>

                    }
                </div>
                <div class="buttons">
                    <button customButton type="submit" [styleType]="'secondary'" [isLoading]="false" label="elemento.generico-botao.aceitar" (click)="acceptSelectedCookies()"></button>
                </div>
            </div>
        </div>
        <ngx-ui-loader [loaderId]="'loader-cookie-management'"></ngx-ui-loader>
    </div>
</ng-template>
